import { NoteStatus, NoteType } from "@/api/dtos";

const mapping: Record<NoteStatus, string> = {
    [NoteStatus.Closed]: 'Closed',
    [NoteStatus.New]: 'New',
    [NoteStatus.NotApplicable]: 'Not Applicable',
    [NoteStatus.ResolutionProposed]: 'Resolution Proposed',
    [NoteStatus.Updated]: 'Updated',
};

const noteStatusToText = (status?: NoteStatus) => {
    if (!status) {
        return 'Unknown'
    }

    return mapping[status];
}

export default noteStatusToText;